import { Component, Vue } from "vue-property-decorator";

const style = require("./index.module.scss");

@Component({ name: "YXHSignContract" })
export default class YXHSignContract extends Vue {
  // 年月日
  private renderDate() {
    const d = new Date();
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
  }

  private render() {
    return (
      <div class={style.YXHSignContract}>
        <p class={style.title}>
          <strong>电子签名数字证书用户使用须知</strong>
        </p>
        <p>
          <strong>尊敬的订户：</strong>
        </p>
        <p>
          &nbsp;&nbsp;重庆程远未来电子商务服务有限公司（以下简称“程远未来”）是基于实名认证为互联网用户颁发数字证书，由工信部、国家密码局认可的合法第三方电子认证服务机构。作为权威的第三方电子认证机构，程远未来通过授权的注册机构向用户发放数字证书。
        </p>
        <p>
          &nbsp;&nbsp;订户在申请使用程远未来签发的数字证书之前，应仔细阅读下列使用须知。
        </p>
        <p>
          <strong>一、定义与解释</strong>
        </p>
        <p>
          &nbsp;&nbsp;1、数字证书，是程远未来为订户颁发的用于识别订户身份的数字身份。数字证书及其对应的私钥构成电子签名制作数据，用于数据电文的电子签名。可靠电子签名与手写签名或者盖章具有同等法律效力。
        </p>
        <p>
          &nbsp;&nbsp;2、电子签名依赖方（以下简称“依赖方”），是指基于对电子签名数字证书或者电子签名的信赖从事有关业务活动的人或机构。依赖方为电子签名人或机构提供业务活动的平台，简称“依赖方平台”。
        </p>
        <p>
          &nbsp;&nbsp;3、订户，即依赖方平台的用户中接受了程远未来提供电子认证服务的实体，包括个人和机构。
        </p>
        <p>
          &nbsp;&nbsp;4、注册机构，是由电子认证服务机构授权具有下列一项或多项功能的实体：
        </p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;（1）处理识别和鉴别数字证书申请人；</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;（2）同意或拒绝数字证书的申请；</p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（3）在某些环境下主动撤销或挂起数字证书，处理订户撤销或挂起其数字证书的请求；
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（4）同意或拒绝订户更新其数字证书或密钥的请求。
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;
          在某些情况下，程远未来会授权为订户提供业务活动的依赖方作为注册机构对订户进行身份鉴别并行使注册机构的相关职责。
        </p>
        <p>
          <strong>一、定义与解释</strong>
        </p>
        <p>
          &nbsp;&nbsp;1、请订户按照程远未来规定的数字证书申请流程提供有关资料，并保证所填写的注册信息和所提供的资料的真实性、准确性和完整性，否则程远未来有权拒绝订户的申请请求。
        </p>
        <p>
          &nbsp;&nbsp;2、如数字证书信息在数字证书有效期限内变更的，订户应当及时通过依赖方平台或直接告知程远未来，并终止使用该数字证书。
        </p>
        <p>
          &nbsp;&nbsp;3、订户已同意程远未来向有关部门、授权的注册机构和个人核实订户的信息。程远未来有权合法收集、处理、传递及应用订户的资料，并按照国家有关规定及本使用须知的约定对订户资料保密。
        </p>
        <p>
          &nbsp;&nbsp;4、订户独立享有数字证书的使用权，同时因使用数字证书产生的义务、责任由订户自行承担。
        </p>
        <p>&nbsp;&nbsp;5、数字证书应当在有效期限内使用。</p>
        <p>
          &nbsp;&nbsp;6、数字证书有效期限届满，订户需要继续使用的，应当通过依赖方平台或直接向程远未来办理数字证书更新手续。
        </p>
        <p>
          &nbsp;&nbsp;7、程远未来不负责订户的数字证书私钥保管。无论订户是自行或使用其他方式保管，还是委托依赖方进行保管，订户都应当妥善保管数字证书私钥。如因订户或私钥托管方原因致使数字证书私钥泄露、损毁或者丢失的，程远未来不承担赔偿责任。
        </p>
        <p>
          &nbsp;&nbsp;8、如数字证书私钥在数字证书有效期内损毁、丢失、泄露的，订户应当及时通过依赖方平台或直接向程远未来申请办理撤销手续。在撤销生效前发生的损失由订户承担。
        </p>
        <p>
          &nbsp;&nbsp;9、订户知悉数字证书私钥已经丢失或者可能已经丢失时，应当及时通过依赖方平台或直接告知程远未来，协助程远未来完成撤销该数字证书的工作，并终止使用该数字证书。
        </p>
        <p>
          &nbsp;&nbsp;10、订户有下列情形之一，程远未来有权撤销数字证书并不承担任何责任。由此给程远未来造成损失的，订户应当向程远未来承担赔偿责任：
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（1）订户提供的资料或者信息不真实、不完整或者不准确的；
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（2）订户所填写的注册信息或所提供的资料有变更，订户未书面通知程远未来并终止使用该数字证书的；
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（3）订户已知悉数字证书私钥丢失或者可能丢失时，未终止使用该数字证书并通知程远未来的；
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（4）订户超过数字证书的有效期限但仍使用数字证书的；
        </p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;（5）订户将数字证书用于违法、犯罪活动的。</p>
        <p>
          &nbsp;&nbsp;11、程远未来有下列情形并对订户造成损失的，向订户承担赔偿责任：
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（1）由于程远未来原因导致将数字证书签发给订户以外的第三方；
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（2）由于程远未来原因导致数字证书中的信息错误；
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（3）由于程远未来原因导致数字证书私钥被破译。
        </p>
        <p>
          &nbsp;&nbsp;订户应当在以上情形出现之日起两年内向程远未来提出赔付申请。逾期不申请的，视为订户放弃请求程远未来赔付的权利。
        </p>
        <p>
          &nbsp;&nbsp;因地震、洪水自然灾害、电力故障及通讯故障等不可抗力因素造成订户损失的，程远未来不承担任何责任。
        </p>
        <p>
          &nbsp;&nbsp;12、订户向程远未来提出赔付申请时，应当提交下列材料并协助程远未来完成相应的调查工作：
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（1）能够证明订户身份的材料，如：身份证、护照、企业法人营业执照等；
        </p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;（2）能够证明订户遭受损失的材料；</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;（3）能够证明程远未来有过错的材料；</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;（4）其他应当提交的材料。</p>
        <p>
          &nbsp;&nbsp;13、程远未来有权通过依赖方平台以互联网上公开发布的方式修改本使用须知，如做出实质性变更，订户有权拒绝修改并应在公布的合理期限内向程远未来提出异议并与程远未来协商达成一致。
        </p>
        <p>
          &nbsp;&nbsp;14、程远未来与订户因数字证书申请、使用、服务等相关事宜产生争议且协商不成的，不论金额大小，程远未来与订户均同意按照订户最终使用其申请的电子签名签署的协议中的争议解决条款确定管辖权归属。
        </p>
        <p>
          &nbsp;&nbsp;15、本使用须知为不可撤销要约，承诺期限为两年。程远未来通过盖章方式对本要约内容加以确认并在依赖方平台上进行展示。订户在依赖方平台点击本使用须知的，本要约生效；承诺期内订户在依赖方平台上通过包括但不限于点击、勾选、手写签名等方式之一或方式的结合签署《电子签名数字证书用户申请确认函》的，即表示订户作出了同意本要约的承诺。程远未来与订户之间的数字证书服务合同成立并生效，程远未来将为订户生成数字证书。程远未来与订户将依照本使用须知和订户签署的《电子签名数字证书用户申请确认函》的内容行使权利和履行义务。
        </p>
        <p class={style.idCard}>重庆程远未来电子商务服务有限公司</p>
        <p class={style.idCard}>日 期：{this.renderDate()}</p>
      </div>
    );
  }
}
